export default __webpack_public_path__ + "static/EC40-cfd637f96a98f748b8ca95ac55195744.jpg";